import React from "react";
import Logo from "./Logo";
import {FadeUp} from "./AnimationLibrary";
import VersionInfo from "./VersionInfo";

const Header = (props) => {
	return (
		<FadeUp delay="0">
			<section className="page-banner">
				<div className="container">
					<nav id="banner">
						<a href="https://www.dartmouth.edu">
							<Logo />
						</a>
					</nav>
					<VersionInfo apiService={props.apiService}/>
				</div>
			</section>
		</FadeUp>
	);
};

export default Header;
